<template>
  <div class="footer">
    <!-- Aba Estudo: todos os botões -->
    <template v-if="activeTab === 'estudo'">
      <md-button
        :title="$t('dicom_plus.select_attachments')"
        class="btn-anexar-arquivos"
        @click="$emit('anexar-arquivos')"
      >
        <span class="material-icons" style="color: #fff">attach_file</span>
      </md-button>
      <md-button
        :title="$t('dicom_plus.view_exam')"
        style="color: #fff"
        class="btn-primary"
        @click="$emit('visualizar-exame')"
      >
        <span class="material-icons">visibility</span>
      </md-button>
      <md-button
        :title="$t('dicom_plus.duplicate_exam')"
        :disabled="
          examStatus !== constants.DICOM_PLUS_STATUS.PENDENTE &&
          examStatus !== constants.DICOM_PLUS_STATUS.REVISADO &&
          examStatus !== constants.DICOM_PLUS_STATUS.EXAME_CRIADO
        "
        style="color: #fff"
        class="btn-duplicar"
        @click="$emit('duplicar-exame')"
      >
        <span class="material-icons">note_add</span>
      </md-button>
      <div class="separator"></div>
      <md-button class="md-raised" @click="$emit('close')">{{ $t('close') }}</md-button>
      <md-button
        :disabled="
          (examStatus !== constants.DICOM_PLUS_STATUS.PENDENTE &&
            examStatus !== constants.DICOM_PLUS_STATUS.REVISADO &&
            examStatus !== constants.DICOM_PLUS_STATUS.EXAME_CRIADO) ||
          (examStatus === constants.DICOM_PLUS_STATUS.REVISADO && !hasDuplicacao)
        "
        class="btn-primary btn-save"
        style="color: #fff"
        type="submit"
        @click="$emit('save')"
        >{{ $t('save') }}</md-button
      >
    </template>

    <!-- Aba Mamografia: anexar, fechar, salvar -->
    <template v-else-if="activeTab === 'mamografia'">
      <div class="mammogram-attachment-action-wrapper">
        <md-button
          :title="$t('dicom_plus.select_attachments')"
          style="color: #fff"
          class="btn-anexar-arquivos"
          @click="$emit('anexar-arquivos')"
        >
          <span class="material-icons" style="color: #fff">attach_file</span>
        </md-button>
        <span v-if="attachedFilesCount > 0" class="badge">
          {{ attachedFilesCount > 99 ? '99+' : attachedFilesCount }}
        </span>
      </div>
      <div class="separator"></div>
      <md-button class="md-raised" @click="$emit('close')">{{ $t('close') }}</md-button>
      <md-button
        :disabled="
          (examStatus !== constants.DICOM_PLUS_STATUS.PENDENTE &&
            examStatus !== constants.DICOM_PLUS_STATUS.REVISADO &&
            examStatus !== constants.DICOM_PLUS_STATUS.EXAME_CRIADO) ||
          (examStatus === constants.DICOM_PLUS_STATUS.REVISADO && !hasDuplicacao)
        "
        class="btn-primary btn-save"
        style="color: #fff"
        type="submit"
        @click="$emit('save')"
        >{{ $t('save') }}</md-button
      >
    </template>

    <!-- Aba Paciente e Complementares: fechar, salvar -->
    <template v-else>
      <md-button class="md-raised" @click="$emit('close')">{{ $t('close') }}</md-button>
      <md-button
        :disabled="
          (examStatus !== constants.DICOM_PLUS_STATUS.PENDENTE &&
            examStatus !== constants.DICOM_PLUS_STATUS.REVISADO &&
            examStatus !== constants.DICOM_PLUS_STATUS.EXAME_CRIADO) ||
          (examStatus === constants.DICOM_PLUS_STATUS.REVISADO && !hasDuplicacao)
        "
        class="btn-primary btn-save"
        style="color: #fff"
        type="submit"
        @click="$emit('save')"
        >{{ $t('save') }}</md-button
      >
    </template>
  </div>
</template>

<script>
  import constants from '../../../shared/constants/constants'

  export default {
    name: 'DicomPlusModalFooter',
    props: {
      activeTab: { type: String, required: true },
      examStatus: { type: Number, required: true },
      attachedFilesCount: { type: Number, default: 0 },
      hasDuplicacao: { type: Boolean, default: false }
    },
    data() {
      return {
        constants
      }
    }
  }
</script>

<style scoped>
  .footer {
    flex-shrink: 0;
    background: #fff;
    border-top: 1px solid #e1e6ed;
    padding: 24px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
    position: sticky;
    bottom: 0;
    left: 0;
    z-index: 2;
  }
  .badge {
    background-color: #dc3545;
    color: white;
    border-radius: 50%;
    font-size: 12px;
    position: absolute;
    top: -8px;
    right: -8px;
    text-align: center;
    align-items: center;
    justify-content: center;
    padding: 1px 8px;
    min-width: 20px;
    height: 20px;
    display: flex;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  }
  .separator {
    display: inline-block;
    width: 2px;
    margin: 0 12px;
  }
  .btn-anexar-arquivos {
    background-color: #28863a;
    color: #fff;
  }
  .btn-duplicar {
    background-color: #c73b51;
    color: #fff;
  }
  .mammogram-attachment-action-wrapper {
    display: inline-block;
    position: relative;
  }
  .separator {
    display: inline-block;
    width: 2px;

    margin: 0 12px;
  }
  .btn-duplicar:disabled,
  .btn-anexar-arquivos:disabled,
  .btn-anexar-arquivos[disabled],
  .btn-save:disabled,
  .btn-save[disabled],
  .btn-duplicar[disabled] {
    background: #e0e0e0;
    color: #aaa;
    border: 1px solid #ccc;
    opacity: 0.8;
  }
  .badge {
    background-color: #dc3545;
    color: white;
    border-radius: 50%;
    font-size: 12px;
    position: absolute;
    top: -8px;
    right: -8px;
    text-align: center;
    align-items: center;
    justify-content: center;
    padding: 1px 8px;
    min-width: 20px;
    height: 20px;
    display: flex;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  }
  @media (max-width: 768px) {
    .footer {
      justify-content: stretch;
      gap: 8px;
      padding: 12px;
    }
    .separator {
      display: none;
    }
    .md-button {
      flex: 1 1 calc(50% - 8px);
      min-width: 0;
      min-height: 40px;
      margin: 0 !important;
    }

    .mammogram-attachment-action-wrapper {
      display: flex;
      flex: 1 1 100%;
      min-width: 0;
    }

    .mammogram-attachment-action-wrapper .btn-anexar-arquivos {
      width: 100%;
    }

    .btn-anexar-arquivos,
    .btn-primary:not(.btn-save),
    .btn-duplicar {
      flex-basis: calc(33.333% - 8px);
    }

    .btn-save,
    .md-raised {
      flex-basis: calc(50% - 8px);
    }

  }

  @media (max-width: 420px) {
    .mammogram-attachment-action-wrapper + .md-raised,
    .btn-save {
      flex-basis: calc(50% - 8px);
    }
  }
</style>
